import type {
  GraFxIntegrationSettingsInput,
  GraFxIntegrationSettingsView,
  SftpIntegrationSettingsInput,
  SftpIntegrationSettingsView,
} from '@grafx-vdp/shared';

import { apiFetch } from './client.js';

export interface GrafxIntegrationResponse {
  configured: boolean;
  settings: GraFxIntegrationSettingsView | null;
}

export interface SftpIntegrationResponse {
  configured: boolean;
  settings: SftpIntegrationSettingsView | null;
}

export function getGrafxIntegration(jwt: string | null): Promise<GrafxIntegrationResponse> {
  return apiFetch<GrafxIntegrationResponse>('/api/integrations/grafx', {
    jwt,
    method: 'GET',
  });
}

export function updateGrafxIntegration(
  jwt: string | null,
  body: GraFxIntegrationSettingsInput,
): Promise<GrafxIntegrationResponse> {
  return apiFetch<GrafxIntegrationResponse>('/api/integrations/grafx', {
    jwt,
    method: 'PUT',
    json: body,
  });
}

export function getSftpIntegration(jwt: string | null): Promise<SftpIntegrationResponse> {
  return apiFetch<SftpIntegrationResponse>('/api/integrations/sftp', {
    jwt,
    method: 'GET',
  });
}

export function updateSftpIntegration(
  jwt: string | null,
  body: SftpIntegrationSettingsInput,
): Promise<SftpIntegrationResponse> {
  return apiFetch<SftpIntegrationResponse>('/api/integrations/sftp', {
    jwt,
    method: 'PUT',
    json: body,
  });
}
